/**
 * URL checks for content an agent supplied (pane tiles, links).
 *
 * The server already refuses anything but http(s) in tile data
 * (`backend/omni/modules/pane/components.py`); this is the second check at
 * render time, because a row written before that check, or by a future
 * writer that forgets it, must still not become a `javascript:` link.
 */

/** The URL if it is absolute http(s), otherwise `undefined`. */
export function safeHttpUrl(raw: unknown): string | undefined {
  if (typeof raw !== "string" || !raw) return undefined;
  try {
    const u = new URL(raw);
    return u.protocol === "http:" || u.protocol === "https:" ? u.href : undefined;
  } catch {
    return undefined;
  }
}

/** The host shown beside a link, so a person sees where it goes. */
export function hostOf(url: string): string {
  try {
    return new URL(url).host.replace(/^www\./, "");
  } catch {
    return "";
  }
}
